module.exports = __webpack_public_path__ + "img/Hunter-bloodelf-f-70.d639bf87.gif";